export const TOOLBAR_DATA_HOOK = 'toolbar-v3';
export const TOOLBAR_BUTTONS = 'toolbar-v3-visible';
